import React, {Component} from 'react';
import UserAttributesRow from "./UserAttributesRow";
import {PropTypes} from 'prop-types';
import * as messageConstants from '../../../shared/messages';

class UserAttributesTable extends Component {
  static propTypes = {
    onRowAdd: PropTypes.func,
    onRowDel: PropTypes.func,
    onUserAttributesTableUpdate: PropTypes.func,
    userAttributes: PropTypes.any,
  }

  handleRowAdd = () => {
    this.props.onRowAdd();
  }

  handleRowDel = (target) => {
    this.props.onRowAdd(target);
  }

  render() {
    const userAttributeRows = this.props.userAttributes
        ? this.props.userAttributes.map(
            (userAttribute, index) =>
                <UserAttributesRow
                    onUserAttributesTableUpdate={this.props.onUserAttributesTableUpdate}
                    userAttribute={userAttribute}
                    onRowDel={this.props.onRowDel}
                    id={index}
                    key={index}/>
        ) : [];

    return (
        <div>
          <table>
            <tbody>
            {userAttributeRows.length > 0 ? <tr>
              <th className="attribute-name-title">
                {messageConstants.USER_ATTRIBUTE_NAME}
              </th>
              <th className="attribute-dropdown-title pl-12">
                {messageConstants.ATTRIBUTE_MAPPING}
              </th>
            </tr> : null}
            {userAttributeRows}

            <tr>
              <td className="add-attribute">
                <button type="button" onClick={this.handleRowAdd}
                        className="attr-button">
                  <span className="fa fa-plus btn-circle btn-plus"/>
                  <span
                      className="attr-button-label">{messageConstants.BUTTON_ADD_ATTRIBUTE}</span>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
          <br/>
        </div>
    );

  }

}

export default UserAttributesTable;



// WEBPACK FOOTER //
// ./src/components/AddSAML/UserAttributes/UserAttributesTable.js